import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Button, Paper, Tooltip, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {Link, useLocation, useNavigate} from "react-router-dom";
import UnitService from "../../../../../API/orders/warehouse/UnitService";
import EstimateService from "../../../../../API/orders/estimate/organization/EstimateService";
import DateRangeFilter from "../../../filter/DateRangeFilter";
import {estimateStatuses} from "../../../../../data/EstimateState";
import ModalOpenSetStatus from "./ModalOpenSetStatus";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import {BreadcrumbsComponent} from "../../../breadcrumb/BreadcrumbComponent";
import ButtonBack from "../../../button/ButtonBack";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import {handlerExport} from "../../../../../pages/common/settings/handlerExport";
import MaterialEstimateUnitService from "../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import MenuItem from "@mui/material/MenuItem";
import {constantsErrorMessages} from "../../../../../Constants";
import ModalAlert from "../../customer-detales/ModalAlert";
import DataUtil from "../../../../../utils/common/DataUtil";
import {calcFilterData} from "../../../../../utils/common/calcFilterData";
import ButtonSelectAction from "../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../modal/ModalSelectAction";
import selectionTableUtil, {
    getFieldsArrayByRowSelection,
    normalizeSelection
} from "../../../../../utils/common/SelectionTableUtil";
import {HeaderOPTAdditionally} from "../../orders/organization/production/HeaderOPT";
import CellOPTm from "../../orders/organization/production/CellOPTm";
import {RequestsPurchaseTableFilterData} from "../../../../../data/FilterTables/RequestsPurchaseTableFilterData";
import OrderUtil from "../../../../../utils/orders/OrderUtil";
import CircularProgress from "@mui/material/CircularProgress";

const RequestsPurchaseTable = () => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [currents, setCurrents] = useState({});
    const [change, setChange] = useState(false);
    const [rowSelection, setRowSelection] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [modalStatusOpen, setModalStatusOpen] = useState(false);
    const [open, setOpen] = useState(false)
    const [estimateState, setEstimateState] = useState(null);
    const [alertData, setAlertData] = useState({});
    const [planningList, setPlanningList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [filteredData, setFilteredData] = useState(data)
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [loading, setLoading] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [showColumnFilters, setShowColumnFilters] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState?.pageSize !== tableOptions?.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState?.pageSize)
        }
    }

    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, RequestsPurchaseTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [RequestsPurchaseTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(pathname, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        const searchQuery = pagesData[pathname]?.searchQuery

        return {searchQuery, pageSize}
    }

    const handleCreateNewRow = (values) => {
        data.push(values);
        setData([...data]);
    };

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        EstimateService.getAllNotCalculationAndNotArchive().then(function (response) {
            const data = response.data;
            setData(data);
            setPlanningList(DataUtil.getListField(data, 'namePlan'));
            setStatusList(OrderUtil.getListFieldByEnum(data, 'estimateState', estimateStatuses));
            handleSearchQuery(searchQuery, data, pageSize)
            data.forEach((row) => {
                currents[row.id] = row.current;

            });
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setIsLoading(false))

    }, [change]);

    const handleSaveRowEdits = async ({exitEditingMode, row, values}) => {
        UnitService.update(values)
            .then(function () {
                const newData = data.map(el => el.id === row.id ? values : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
        exitEditingMode();
    };


    const handleDeleteRow = useCallback(
        (row) => {
            UnitService.delete(row.id)
                .then(function () {
                    const newData = data.filter(el => el.id !== row.id)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );

    const redirectOrders = () => {
        navigate('/organization/orders/');
    };

    const updateStatusByIds = async () => {
        EstimateService.setStatus(selectedIds, estimateState)
            .then(function () {
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
        handleCloseModalStatus();
    }

    const handleCloseModalStatus = () => {
        setModalStatusOpen(false);
    };

    const columns = useMemo(
        () => [
            {
                id: 'number',
                header: 'Номер',
                accessorKey: 'number',
                size: 80
            },
            {
                id: 'order',
                header: 'Заказ',
                accessorKey: 'orderNumber',
                size: 700,
                Cell: ({cell, row}) => (
                    <li key={cell.getValue()}>
                        <Link
                            to={'/organization/requests-purchase/' + row.original.id + '/' + row.original.orderId + '/' + encodeURIComponent(row.original.orderNumber) + '/' + row.original.estimateState}>{cell.getValue()}</Link>
                    </li>
                ),
            },
            {
                id: 'namePlan',
                header: 'План',
                accessorFn: (row) => row.namePlan,
                filterVariant: 'multi-select',
                filterSelectOptions: planningList,
                size: 80,
                Cell: ({cell, row}) => (
                    <>
                        {row.original?.planId !== null && (
                            <Link
                                to={'/organization/plans/' + row.original?.planId + "/" + encodeURIComponent(row.original?.namePlan)}>{row.original?.namePlan}</Link>
                        )}
                    </>
                ),
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по план',
                    sx: {
                        width: '100px',
                    },
                }
            },
            {
                id: 'estimateState',
                header: 'Статус',
                accessorKey: 'estimateState',
                filterVariant: 'multi-select',
                filterSelectOptions: statusList,
                minSize: 20,
                maxSize: 20,
                Cell: ({cell}) => estimateStatuses[cell.getValue()],
                filterFn: (row, id, filterValue) => {
                    return estimateStatuses[row.original.estimateState].toLowerCase().includes(filterValue.toLowerCase())
                },
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по статус',
                    sx: {
                        width: '120px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.date === null) {
                    } else {
                        return new Date(row.date)
                    }
                },
                id: 'date',
                header: 'Дата',
                sortingFn: 'datetime',
                size: 10,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString();
                    }
                },
                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'reservedUnits',
                header: 'Созданы резервы',
                accessorKey: 'reservedUnits',
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    cellEstimate={row.original.totalUnits === 0 ? 0 : row.original.reservedUnits / row.original.totalUnits * 100}
                />
            },
            {
                id: 'inStockUnits',
                header: 'В наличии',
                accessorKey: 'inStockUnits',
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    cellEstimate={row.original.totalUnits === 0 ? 0 : row.original.inStockUnits / row.original.totalUnits * 100}
                />
            },
            {
                id: 'waitingForDeliveryUnits',
                header: 'Ожидает поставки',
                accessorKey: 'waitingForDeliveryUnits',
                size: 40,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    requestsPurchase={true}
                    bigCell={true}
                    cellEstimate={row.original.totalUnits === 0 ? 0 : row.original.waitingForDeliveryUnits / row.original.totalUnits * 100}
                />
            },
            {
                id: 'executorForApplicationUnits',
                header: 'Сформирована закупка',
                accessorKey: 'executorForApplicationUnits',
                size: 40,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    requestsPurchase={true}
                    bigCell={true}
                    cellEstimate={row.original.totalUnits === 0 ? 0 : row.original.executorForApplicationUnits / row.original.totalUnits * 100}
                />
            },
            {
                id: 'waitingForApplicationUnits',
                header: 'Ожидает закупки',
                accessorKey: 'waitingForApplicationUnits',
                size: 40,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    requestsPurchase={true}
                    bigCell={true}
                    cellEstimate={row.original.totalUnits === 0 ? 0 : row.original.waitingForApplicationUnits / row.original.totalUnits * 100}
                />
            },
            {
                id: 'wait',
                header: 'Ожидает действий',
                accessorKey: 'wait',
                size: 40,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    requestsPurchase={true}
                    bigCell={true}
                    cellEstimate={row.original.totalUnits === 0 ? 0 : row.original.wait / row.original.totalUnits * 100}
                />
            },
            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ],
        [data, setData, filteredData],
    );
    const handleSubmitExport = (row) => {
        handlerExport(() => MaterialEstimateUnitService.export(row.id, row.orderNumber), handleModalAlert)
    }

    const menuItem = [
        {type: "download", text: "Экспорт", handler: handleSubmitExport}
    ]
    const modalActions = [
        {name: "Создать резервы", type: "createReserves"},
        {name: "Отправить на закупку", type: "sendPurchase"},
    ]

    const handleSelectAction = (type, ignoreSlab, handleCancel) => {
        const orderIds = getFieldsArrayByRowSelection(data, rowSelection, "orderId")
        setLoading(true)

        if (type === "createReserves") {
            EstimateService.createReservesForPurchaseByIds(orderIds, ignoreSlab).then(function () {
                setRowSelection([])
                handleCancel()
                handleModalAlert("Резервы созданы", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        } else {
            EstimateService.setPurchaseByIds(orderIds, ignoreSlab).then(function () {
                setRowSelection([])
                handleCancel()
                handleModalAlert("Данные отправлены на закупку", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }
    }
    return (
        <Box sx={{maxWidth: "1550px", padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Заявки на закупку"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box
                sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
            >
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>Заявки на закупку</Typography>
                <ButtonBack
                    text={"Вернуться в заказы"}
                    width={200}
                    onClick={redirectOrders}
                />
            </Box>
            {isLoading ?
                <Box sx={{
                    height: `calc(100vh - 430px)`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress disableShrink/>
                </Box> : <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            maxHeight: rowSelection?.length > 0 ? `calc(100vh - 530px)` : `calc(100vh - 430px)`,
                            width: "1550px"
                        }
                    }}
                    muiTableBodyCellProps={({cell}) => {
                        return ({
                            sx: {
                                p: ['mrt-row-select', "mrt-row-actions"].includes(cell.column.id) ? "0 10px" : '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                "&:after": {
                                    display: "none",
                                },
                                "& td:after": {
                                    "&:hover": {
                                        backgroundColor: "red"
                                    }
                                },
                                "&:first-of-type": {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "&:nth-of-type(n+8)": {
                                    padding: 0,
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }
                            },
                        })
                    }}
                    muiTableHeadCellProps={({table, column}) => {
                        return ({
                            sx: {
                                border: '1px solid #EAEBEA',
                                backgroundColor: "#F5F6FA",
                                padding: ['mrt-row-select', "mrt-row-actions"].includes(column.id) ? "0 5px" : ["reservedUnits", "inStockUnits", "waitingForDeliveryUnits", "executorForApplicationUnits", "waitingForApplicationUnits", "wait"].includes(column.id) ? 0 : '0px 0px 0px 10px',
                                verticalAlign: "bottom",
                                "& .Mui-TableHeadCell-Content": {
                                    alignItems: "end",
                                    "& .Mui-TableHeadCell-Content-Wrapper": {
                                        justifyContent: "center",
                                        display: "flex",
                                    },
                                    "& .Mui-TableHeadCell-Content-Labels": {
                                        alignItems: "end",
                                        "& span": {
                                            marginBottom: "3px"
                                        }
                                    }
                                },
                                "& .MuiCollapse-root .MuiSelect-select": {
                                    padding: "0 !important",
                                    "& .MuiChip-label": {
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }
                                }
                            },
                        })
                    }}
                    muiTableBodyRowProps={() => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                            },
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    columns={columns}
                    data={filteredData}
                    onEditingRowSave={handleSaveRowEdits}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 100},
                    }}
                    localization={MRT_Localization_RU}
                    getRowId={(originalRow) => originalRow.id}
                    onRowSelectionChange={onRowSelectionChange}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    onGlobalFilterChange={(value) => {
                        handleSearchQuery(value, data, null)
                    }}
                    onColumnFiltersChange={(updater) => {
                        handleSearchQuery(updater(columnsFilter), data, null, true)
                    }}
                    onShowColumnFiltersChange={handleShowColumnFilters}
                    state={{
                        showColumnFilters: showColumnFilters,
                        columnFilters: columnsFilter,
                        globalFilter: globalFilter,
                        rowSelection: currentSelection,
                        showGlobalFilter: true,
                        pagination: tableOptions
                    }}
                    manualFiltering={true}
                    rowCount={tableOptions.totalElements}
                    enableRowSelection={true}
                    selectionPadding={1}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    enableToolbarInternalActions={false}
                    enableRowActions={true}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                />}
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
            </Paper>}
            <ModalSelectAction
                open={open}
                reset={() => setOpen(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
                ignoreSlab={true}
                ignoreTypes={["createReserves", "sendPurchase"]}
                loading={loading}
            />
            <ModalOpenSetStatus
                title={'Изменить статус'}
                label={'статус'}
                modalOpen={modalStatusOpen}
                handleClose={handleCloseModalStatus}
                setValue={setEstimateState}
                handleSubmit={updateStatusByIds}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default RequestsPurchaseTable;